import constate from "constate";
import { useLayoutEffect, useState } from "react";
import Cookies from "universal-cookie";
//#region src/Cookies/context.ts
var globalCookies = new Cookies();
var setGlobalCookie = globalCookies.set.bind(globalCookies);
var removeGlobalCookie = globalCookies.remove.bind(globalCookies);
function useCookies() {
	const [cookies, setCookies] = useState(globalCookies.getAll());
	useLayoutEffect(() => {
		function onChange() {
			setCookies(globalCookies.getAll());
		}
		globalCookies.addChangeListener(onChange);
		return () => {
			globalCookies.removeChangeListener(onChange);
		};
	}, []);
	return {
		setCookie: setGlobalCookie,
		removeCookie: removeGlobalCookie,
		cookies
	};
}
var dest = constate(useCookies);
var CookiesProvider = dest[0];
var useCookiesContext = dest[1];
//#endregion
export { useCookiesContext as n, CookiesProvider as t };

//# sourceMappingURL=Cookies-Bn7Z7Gm8.js.map